const STORAGE_KEY = "app/language"

export default {
  STORAGE_KEY
}
